import styled from 'styled-components';

export const Header = styled.div`
  text-align: center;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    color: #333333;
    font-weight: 500;
  }
  .go-back {
    display: none;
  }

  @media screen and (max-width: 768px) {
    background: #fff;
    position: absolute;
    top: 0;
    height: 52px;
    line-height: 52px;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #dbdbdb;

    .go-back {
      position: absolute;
      top: 0;
      left: 15px;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
`;
